import MMenu from 'mmenu-js';
import $ from 'jquery';

export default class SearchBar {
  constructor() {
    this.activeNavLink = null;

    $('body')
      .on('mouseenter mouseleave', '.navbar .nav-item', this.toggleActive)
      .on('mouseenter', '.navbar .category-groups [data-group]', this.toggleCategoriesMenu)
      .on('mouseenter mouseleave', '.navbar .megamenu', this.toggleDropdown)
      .on('click', '.navbar .dropdown-toggle', this.handleClick);

    const mobileNav = document.querySelector('#mobile-nav');
    if (mobileNav) {
      const $menuArrow = $('.menu-arrow');
      const menu = new MMenu(mobileNav, {
        extensions: ['position-top', 'border-full', 'theme-white'],
        navbar: { title: '' },
        autoHeight: false,
        navbars: true,
        hooks: {
          'openPanel:start': (panel) => {
            if (panel.id === 'mm-0') {
              $('nav#mobile-nav').find('.mm-navbars_top .mm-navbar').addClass('mm-hidden');
              $('.menu-arrow').removeClass('arrow-submenu');
            } else {
              $('nav#mobile-nav').find('.mm-navbars_top .mm-navbar').removeClass('mm-hidden');
              $('.menu-arrow').addClass('arrow-submenu');
            }
          },
          'open:after': () => $menuArrow.removeClass('d-none arrow-search'),
          'close:after': () => $menuArrow.addClass('d-none')
        }
      }, {
        offCanvas: {
          menu: { insertSelector: '.nav-wrapper' },
          page: { selector: '#body-wrapper' }
        }
      });

      const api = menu.API;
      window.menu = menu;

      $('#menu').on('click', (e) => {
        if (mobileNav.classList.contains('mm-menu_opened')) {
          api.close();
        } else {
          api.open();
        }

        e.preventDefault();
        e.stopPropagation();
      });
    }

    const mobileSearch = document.querySelector('#mobile-search');
    if (mobileSearch) {
      const $menuArrow = $('.menu-arrow');
      const menuSearch = new MMenu(mobileSearch, {
        extensions: ['position-top', 'theme-white'],
        navbar: false,
        hooks: {
          'open:after': () => $menuArrow.removeClass('d-none arrow-submenu').addClass('arrow-search'),
          'close:after': () => $menuArrow.addClass('d-none')
        }
      }, {
        offCanvas: {
          menu: { insertSelector: '.nav-wrapper' },
          page: { selector: '#body-wrapper' }
        }
      });

      const api = menuSearch.API;
      window.menu = menuSearch;

      $('#search').on('click', (e) => {
        if (mobileSearch.classList.contains('mm-menu_opened')) {
          api.close();
        } else {
          api.open();
        }

        e.preventDefault();
        e.stopPropagation();
      });
    }
  }

  toggleActive({ type }) {
    if (type === 'mouseenter') {
      this.activeNavLink = $('.navbar .nav-link.active');
      this.activeNavLink.removeClass('active');
    } else {
      if (this.activeNavLink) {
        this.activeNavLink.addClass('active');
      }
      this.activeNavLink = null;
    }
  }

  toggleDropdown(e) {
    const dropdown = $(e.target).closest('.dropdown');
    const menu = $('.dropdown-menu', dropdown);

    setTimeout(() => {
      const shouldOpen = dropdown.is(':hover');
      menu.toggleClass('show', shouldOpen);
      dropdown.toggleClass('show', shouldOpen);
      $('[data-toggle="dropdown"]', dropdown).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 300 : 0);
  }

  toggleCategoriesMenu(e) {
    const link = $(e.target);
    const categoryGroup = link.data('group');
    const categoryList = $(`.category-list[data-group="${categoryGroup}"]`);

    // Handle class on category group links
    link.closest('.category-groups').find('[data-group]').removeClass('active');
    link.addClass('active');

    // Handle what categories list to show
    categoryList.siblings().removeClass('active');
    categoryList.addClass('active');
  }

  handleClick(e) {
    const link = $(e.target);
    const status = link.attr('aria-expanded');
    const target = link.attr('href');

    if (status === 'true' && target !== '#') {
      window.location.href = target;
    }
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/nav-bar.js